/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Equipment {
    "use strict";

    export class equipmentContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            rootScope: ng.IRootScopeService) {
          super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null,false);
          this.baseEndpoint = appSettings.API_ENDPOINTS.equipment;
          this.sectionTemplatePath = "app/plugins/equipment/sectionViews/";
          this.buildCrudSecurityKeys(this.securityKeys.DATA_EQUIPMENT_TAB_MAIN);
          this.entityType = 'Equipment';
          this.initializeSections();
        }

        initializeSections(): void {
           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EQUIPMENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_EQUIPMENT_MAIN", "main.html", true, false, this.baseEndpoint, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.EquipmentMain, null, this.securityKeys.DATA_EQUIPMENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        save(): angular.IPromise<any> {
            if (this.mode == Meevo.Model.MaintenanceFormState.Adding) {
                super.usageTrackingLog(Model.VerbEnum.Created, null);
            }
            return super.save();
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.Equipment>();
            model.displayName = undefined;
        }

        delete(): void {
            const section = this.selectedSection as Meevo.Plugins.Equipment.MainSection;

            if (section && section.model.usedByServices) {
                section.showHasServicesPrompt(this)
                    .then(() => {
                        super.delete()
                    });
            } else {
                super.delete();
            }
        }
    }
}